// import * as format from 'date-fns/format'
import * as moment from 'moment'
import * as React from 'react'

export interface DateTimeProps {
  dateTime: Date | string | null
  format?: string
  nullDateTime?: string
}

export class DateTime extends React.Component<DateTimeProps, {}> {
  static defaultProps = {
    format: 'YYYY-MM-DD HH:mm',
    nullDateTime: '?',
  }
  public render() {
    const text = this.props.dateTime
      ? moment(this.props.dateTime).format(this.props.format)
      : this.props.nullDateTime
    return <span>{text}</span>
  }
}
